import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { createStyles, makeStyles, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

export function Label(props) {
  return (
    <div className={css(Styles.labelContainer)}>
      <p className={css(Styles.label)}>{props.label}</p>
    </div>
  )
}

export function SelectBox(props) {
  const useStyle = makeStyles(theme =>
    createStyles({
      option: {
        '&[aria-selected="true"]': {
          backgroundColor: '#037BFE',
        },
      }
    }))

  const highlightedOption = useStyle()

  return (
    <div className={css(Styles.textBoxContainer, props.containerStyle)}>
      <Label label={props.item.key} item={props.item} />
      {props.item && props.item.values &&
        <Autocomplete
          fullWidth
          value={props.value}
          key={props.item.key}
          //name={props.item.key}
          autoComplete='off'
          options={props.item.values} // What needs to be shwon in dropdown
          disabled={props.disabled}
          multiple={true}
          getOptionLabel={(option) => option.value + ' (' + option.count + ')'} // What needs to be shown in the select box once a value is selected
          onChange={(e, val) => props.handleSelectBox(val, props.item.key)} // This is the field key, not dropdown list key
          getOptionSelected={(option) => option.key === props.value.key ? true : false} // getting the selected value from dropdown. This should be based on key.
          classes={{
            paper: css(Styles.selectBoxPaper),
            popper: css(Styles.listBoxPaper),
            popupIndicator: css(Styles.dropDownIndicator),
            clearIndicatorDirty: css(Styles.clearIndicator),
            endAdornment: css(Styles.endAdornmentStyle),
            option: highlightedOption.option
          }}
          renderOption={(option) => ( // What needs to be shown dropdownlist
            <p className={css(Styles.selectInputStyles)}>
              {option.value + ' (' + option.count + ')'}
            </p>
          )}
          renderInput={(params) => <TextField {...params}
            placeholder={props.item.placeholder}
            className={css(Styles.textFeildStyle, props.selectStyle)}
            InputProps={{
              ...params.InputProps,
              autoComplete: 'off',
              type: 'text',
              disableUnderline: true,
              classes: {
                root: css(Styles.textInputStyles, Styles.selectInputStyle)
              }
            }} />}
        />
      }
    </div>
  )
}

const Styles = StyleSheet.create({
  textBoxContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 10
  },
  label: {
    fontSize: 16,
    fontWeight: 500,
    color: '#1B1B1B',
    margin: 0,
    textTransform: 'capitalize'
  },
  textFeildStyle: {
    minHeight: 54,
    borderRadius: 16,
    backgroundColor: '#F6F6F8',
  },
  textInputStyles: {
    border: 'none',
    padding: '0px 14px',
    flex: 1,
    textAlign: 'left',
    fontSize: 16,
    color: '#000000',
    '::placeHolder': {
      color: '#747474',
    }
  },
  iconImg: {
    height: 18,
    width: 18,
    marginRight: 10
  },
  sliderOuterContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 23
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8
  },
  labelInfoImgContainer: {
    width: 12,
    height: 12,
    marginLeft: 6,
    objectFit: 'cover'
  },
  img: {
    width: 'auto',
    height: 'auto',
    maxHeight: '100%',
    maxWidth: '100%',
  },
  track: {
    height: 6,
    borderRadius: 4,
    backgroundColor: 'unset'
  },
  rail: {
    height: 6,
    borderRadius: 4,
    backgroundColor: '#F6F6F8 !important'
  },
  sliderRoot: {
    height: 1,
  },
  sliderMark: {
    background: 'unset'
  },
  sliderMarkLabel: {
    color: '#747474',
  },
  CheckboxOuterContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 24
  },
  checkboxLabelContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  checkboxLabel: {
    fontSize: 16,
    fontWeight: 600,
    color: '#1B1B1B',
    margin: 0,
    marginBottom: 6
  },
  checkboxDescr: {
    fontSize: 14,
    fontWeight: 400,
    color: '#747474',
    margin: 0,
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  locationImgContainer: {
    height: 18,
    width: 18,
    marginRight: 6
  },
  radioButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 32
  },
  radioButtonLabelContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 21
  },
  radioButtonLabel: {
    fontSize: 16,
    fontWeight: 600,
    color: '#747474',
    margin: 0,
  },
  fontWeight400: {
    fontWeight: 400
  },
  checkBoxRoot: {
    color: '#747474'
  },
  selectBoxPaper: {
    fontSize: 16,
    backgroundColor: '#F6F6F8',
  },
  dropDownIndicator: {
    marginRight: 8
  },
  clearIndicator: {
    color: '#1B1B1B',
    fontSize: 12
  },
  selectInputStyles: {
    fontSize: 16,
    color: '#000000',
    margin: 0
  }
})


// WEBPACK FOOTER //
// ./src/components/SelectBox.js